import { BaseService } from './base.service';
import { ISupplement } from '@/types/supplement';

export class MemberSupplementService extends BaseService {
  constructor() {
    super('/supplements');
  }

  async getAllForMember(memberId: string): Promise<{ data: ISupplement[] }> {
    const pagination = {
      pageSize: 20,
    }
    return this.post(`/${memberId}/getAll`, { pagination });
  }

  async createForMember(memberId: string, data: ISupplement | ISupplement[]): Promise<ISupplement[]> {
    // If data is an array, wrap in { supplements: [...] } as backend expects
    if (Array.isArray(data)) {
      return this.post(`/${memberId}`, { supplements: data });
    }
    return this.post(`/${memberId}`, data);
  }

  async updateForMember(memberId: string, supplementId: string, data: ISupplement): Promise<ISupplement[]> {
    return this.put(`/${memberId}/${supplementId}`, data);
  }

  async deleteForMember(memberId: string, supplementId: string): Promise<ISupplement[]> {
    return this.delete(`/${memberId}/${supplementId}`);
  }
}

export const memberSupplementService = new MemberSupplementService();
